/* eslint-disable no-console */
import * as React from "react";
import { Container, Typography, Button, makeStyles, createStyles, Theme } from "@material-ui/core";
import CloseAllIcon from "@material-ui/icons/UnfoldLess";
import ExpandAllIcon from "@material-ui/icons/UnfoldMore";
import SearchField from "../../features/SmartFilters/SearchField";
import { EVENT_FAQ_SEARCH_CHANGE } from "../../Events";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing("6.5px", 4),
      display: "flex",
      alignItems: "center",
      background: theme.customPaper.background.cardBackgroundLight,
      divShadow: "0px 2px 3px #0000000D",
      border: `1px solid ${theme.customPaper.background.cardBackgroundLight}`,
      borderRadius: 1,

      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(0.5),
      },
    },

    categoryText: {
      fontSize: "1rem",
      fontWeight: "bold",
      color: theme.customPalette.text.darkgrey,
    },

    menuWrapper: {
      borderLeft: "1px dashed #707070",
      flex: 0.25,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingLeft: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },

    searchFilter: {
      "flex": 2,
      "display": "flex",

      "& .MuiFormControl-root": {
        "flex": 1,
        "color": theme.customPalette.text.darkgrey,
        "background": theme.palette.common.white,

        "& .MuiOutlinedInput-input": {
          padding: "13px 14px",
        },

        "maxWidth": 320,
      },

      "& svg": {
        color: theme.customPalette.svg.lightgrey,
      },
    },

    button: {
      "display": "flex",
      "flex": 1,
      "alignItems": "center",
      "fontSize": "0.8rem",
      "color": theme.palette.text.secondary,

      "& svg": {
        fontSize: "1.5em",
        width: "1.5em",
        height: "1.5em",
      },

      [theme.breakpoints.down("xs")]: {
        "&:first-child:not(.disable-border)": {
          borderBottom: `1px solid ${theme.customPalette.border.gray}`,
        },

        "& p": {
          fontSize: "small",
        },
      },
    },

    svg: {
      color: theme.customPalette.text.darkgrey,
      fontSize: "2.5rem",
    },

    svgLight: {
      color: "rgba(0,0,0,0.3)",
    },

    buildIconSvg: {
      paddingRight: theme.spacing(1),
      color: theme.palette.text.secondary,
    },

    selected: {
      color: theme.palette.primary.main,
    },

    hidden: {
      display: "none",
    },

    wrapper: {
      display: "flex",
      justifyContent: "flex-end",
      flex: 1,
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      },
    },
  })
);

export type FaqPageFilterComponentProps = {
  handleClickExpandAll?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleClickCloseAll?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

function FaqPageFilterComponent(props: FaqPageFilterComponentProps) {
  const { handleClickExpandAll, handleClickCloseAll } = props;

  const classes = useStyles();

  return (
    <Container className={classes.root} maxWidth="xl">
      {/* Pesquisa por texto */}
      <SearchField useCustomEvent eventId={EVENT_FAQ_SEARCH_CHANGE} />

      {/* Botão expandir todos os cards/ rows */}
      <div className={classes.wrapper}>
        <div className={classes.menuWrapper}>
          <Button
            className={classes.button}
            onClick={(e) => (handleClickExpandAll ? handleClickExpandAll(e) : console.log(e))}
          >
            <ExpandAllIcon className={classes.svg} />

            <Typography>Expandir Tudo</Typography>
          </Button>
        </div>

        {/* Botão fechar todos os cards/ rows */}
        <div className={classes.menuWrapper}>
          <Button
            className={clsx(classes.button, "disable-border")}
            onClick={(e) => (handleClickCloseAll ? handleClickCloseAll(e) : console.log(e))}
          >
            <CloseAllIcon className={classes.svg} />

            <Typography>Fechar Tudo</Typography>
          </Button>
        </div>
      </div>
    </Container>
  );
}

export default FaqPageFilterComponent;
